"use strict";

var _regeneratorRuntime2 = require("@babel/runtime/regenerator");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = submitSendBoxSaga;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _effects = require("redux-saga/effects");

var _submitSendBox = require("../actions/submitSendBox");

var _sendBoxValue = _interopRequireDefault(require("../selectors/sendBoxValue"));

var _sendMessage = _interopRequireDefault(require("../actions/sendMessage"));

var _setSendBox = _interopRequireDefault(require("../actions/setSendBox"));

var _whileConnected = _interopRequireDefault(require("./effects/whileConnected"));

var _marked = /*#__PURE__*/_regeneratorRuntime2.mark(submitSendBox),
    _marked2 = /*#__PURE__*/_regeneratorRuntime2.mark(submitSendBoxSaga);

function submitSendBox() {
  return _regenerator["default"].wrap(function submitSendBox$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 2;
          return (0, _effects.takeEvery)(_submitSendBox.SUBMIT_SEND_BOX, /*#__PURE__*/_regenerator["default"].mark(function _callee(_ref) {
            var _ref$payload, channelData, method, sendBoxValue;

            return _regenerator["default"].wrap(function _callee$(_context) {
              while (1) {
                switch (_context.prev = _context.next) {
                  case 0:
                    _ref$payload = _ref.payload, channelData = _ref$payload.channelData, method = _ref$payload.method;
                    _context.next = 3;
                    return (0, _effects.select)(_sendBoxValue["default"]);

                  case 3:
                    sendBoxValue = _context.sent;

                    if (!sendBoxValue) {
                      _context.next = 9;
                      break;
                    }

                    _context.next = 7;
                    return (0, _effects.put)((0, _sendMessage["default"])(sendBoxValue.trim(), method, {
                      channelData: channelData
                    }));

                  case 7:
                    _context.next = 9;
                    return (0, _effects.put)((0, _setSendBox["default"])(''));

                  case 9:
                  case "end":
                    return _context.stop();
                }
              }
            }, _callee);
          }));

        case 2:
        case "end":
          return _context2.stop();
      }
    }
  }, _marked);
}

function submitSendBoxSaga() {
  return _regenerator["default"].wrap(function submitSendBoxSaga$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          _context3.next = 2;
          return (0, _whileConnected["default"])(submitSendBox);

        case 2:
        case "end":
          return _context3.stop();
      }
    }
  }, _marked2);
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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